import { motion } from 'framer-motion';

interface HeroSectionProps {
  title: string;
  description: string;
  patternId?: string;
  height?: string;
}

const HeroSection = ({ 
  title, 
  description, 
  patternId = 'defaultPattern'
}: HeroSectionProps) => {
  return (
    <section className={`relative min-h-[calc(20vh+48px)] md:min-h-[calc(20vh+32px)] bg-forest overflow-hidden pt-4`}>
      <div className="absolute inset-0 bg-gradient-to-br from-forest via-forest-dark to-forest">
        <div className="absolute inset-0 opacity-10">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id={patternId} x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse">
                <circle cx="60" cy="60" r="40" fill="none" stroke="white" strokeWidth="1"/>
                <circle cx="60" cy="60" r="25" fill="none" stroke="white" strokeWidth="0.5"/>
                <circle cx="60" cy="60" r="10" fill="none" stroke="white" strokeWidth="0.5"/>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill={`url(#${patternId})`} />
          </svg>
        </div>
      </div>
      
      <div className="relative z-10 container-custom min-h-full flex items-center py-6 md:py-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-white max-w-4xl"
        >
          <h1 className="heading-section font-semibold mb-3 tracking-wide">
            {title}
          </h1>
          <p className="text-2 md:text-3 opacity-95 font-medium leading-relaxed">
            {description}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;

